import { AxiosError } from "axios";
import { DefaultOtpType } from "../../api/user/model";
import { GET_OTP_DETAILS_URL } from "../../constants/apiUrls"
import { GET_OTP_DETAILS_QUERY_KEY } from "../../constants/queryKeys";
import axiosClient from "../axiosClient";
import { useCustomQuery } from "../utils/useCustomQuery";
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface OtpDetailsResponse {
  email: {
    emailAddress: string;
    resendTime: number;
  };
  sms: {
    contactNumber: string;
    resendTime: number;
  };
  defaultOtpType: DefaultOtpType;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  enabled?: boolean;
  onSuccess?: (data: OtpDetailsResponse) => Promise<void>;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetOtpDetails = ({ enabled = true, onSuccess, onError }: Input) => {
  const getOtpDetails = async () => {
    const res = await axiosClient.get<OtpDetailsResponse>(GET_OTP_DETAILS_URL);

    return res.data;
  }

  return useCustomQuery([GET_OTP_DETAILS_QUERY_KEY], getOtpDetails, {
    onSuccess,
    onError,
    retryOnMount: false,
    refetchOnWindowFocus: false,
    cacheTime: 0,
    enabled
  }, false)
}
